import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid} from '../question-helper';

@Component({
    selector: 'app-question-textbox-percentage',
    templateUrl: './question-textbox-percentage.component.html',
    styleUrls: ['./question-textbox-percentage.component.scss'],
    standalone: false
})
export class QuestionTextboxPercentageComponent implements OnInit, OnChanges {

  @Input() question: Question;
  @Input() showDelete = false;
  @Output() questionAnswer = new EventEmitter<any>();

  value = '';
  description = '';
  uniqueDescriptionControlName = `textbox-percentage-description-${newGuid()}`;
  uniqueDescriptionId = `textbox-percentage-description-${newGuid()}`;
  uniqueValueControlName = `textbox-percentage-value-${newGuid()}`;
  uniqueValueId = `textbox-percentage-value-${newGuid()}`;

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.value = '';
    this.description = '';
    if (changes?.question?.currentValue) {
      this.question = changes?.question?.currentValue;
      if (this.question?.answer) {
        this.description = this.question?.answer.split('|')[0];
        this.value = this.question?.answer.split('|')[1];
      }
    }
    if (changes?.showDelete?.currentValue) {
      this.showDelete = changes?.showDelete?.currentValue;
    }
  }

  onChange(): void {
    let answer = '';
    if (this.value && this.description) {
      let num = parseFloat(this.value);
      if (isNaN(num)) {
        num = 0;
      }
      num = Math.min(100, Math.max(0, num));
      this.value = num.toString();
      answer = this.description + '|' + this.value.toString();
    }
    if (this.question) {
      this.question.answer = answer;
      this.questionAnswer.emit(this.question);
    } else {
      this.questionAnswer.emit(answer);
    }
  }
}
